<script setup lang="ts">
withDefaults(defineProps<{ variant?: 'error' | 'success' }>(), { variant: 'error' })
</script>

<template>
  <p :class="['alert', `alert--${variant}`]" role="alert">
    <slot />
  </p>
</template>

<style scoped lang="scss">
.alert {
  margin: 0;
  padding: $space-3 $space-4;
  border-radius: $radius-md;
  font-size: $text-sm;

  &--error {
    background: rgba($color-danger, 0.12);
    border: 1px solid rgba($color-danger, 0.4);
    color: $color-danger;
  }

  &--success {
    background: rgba($color-success, 0.12);
    border: 1px solid rgba($color-success, 0.4);
    color: $color-success;
  }
}
</style>
